export default {
  last: { method: 'get', url: '/notice/last' }, // 最新公告
  page: { method: 'get', url: '/notice/page' }, // 公告分页
  detail: { method: 'get', url: '/notice/detail' } // 公告详情
}
